module.exports = __webpack_public_path__ + "media/images/simplyhired-logo-041d6eebf3ab03c7c176f4e31100feae.jpg";